class Player {
  constructor (type, name, country = null) {
    this.computer = type === "ai" ? true : false;
    this.name = name;
    this.country = country;
    this.events = {};
    this.modifier = "";
    this.research = {
      techResearch: 1,
      domResearch: 1,
      shadyResearch: 0,
      milResearch: 1,
      milFunding: 1,
      domFunding: 1,
      birthing: 1,
      developLand: 0,
      production: 1,
      defenses: 1,
      soldiersTrained: 1,
      militia: 1
    };
    this.shadyMoves = {
      kidnapTarget: -1,
      frameTargets: [-1,-1],
      trojanCube: -1,
      propaganda: -1
    };
  }

  setPerk (perk) {
    this.perk = perk;
  }

  applyModifiers () {
    this.parseModifier();
    this.country.object.learnTech(this.research);
  }

  setShadyMove (num) {
    if (this.computer) {
      this.shadyTarget = this.warTarget;
      this.shadyMove = 0;
    } else {
      this.shadyTarget = this.warTarget;
      this.shadyMove = num;
    }
  }

  parseModifier () {
    switch (this.modifier) {
      case "domestic-1":
        this.research.birthing =
          (1.2 + (0.05 * this.country.object.techPower)) * this.research.domResearch;
        break;
      case "domestic-2":
        this.research.developLand =
          (1.25 + (0.05 * this.country.object.techPower)) * this.research.domResearch;
        break;
      case "domestic-3":
        this.research.production =
          (1.2 + (0.05 * this.country.object.techPower)) * this.research.domResearch;
        break;
      case "domestic-4":
        this.research.domFunding =
          (1.1 + (0.02 * this.country.object.techPower)) * this.research.domResearch;
        break;
      case "military-1":
        this.research.soldiersTrained =
          (1.2 + (0.05 * this.country.object.techPower)) * this.research.domResearch;
        break;
      case "military-2":
        this.research.defenses =
          (1 + (0.05 * this.country.object.techPower)) * this.research.domResearch;
        break;
      case "military-3":
        this.research.militia =
          (2.5 + (0.05 * this.country.object.techPower)) * this.research.domResearch;
        break;
      case "military-4":
        this.research.milFunding = 1.3;
        break;
      case "technology-1":
        this.research.milResearch += 0.25;
        break;
      case "technology-2":
        this.research.domResearch += 0.25;
        break;
      case "technology-3":
        this.research.shadyResearch = 1;
        break;
      case "technology-4":
        this.research.techResearch += 1;
        break;
      case "shady-1":
        this.setShadyMove(1);
        break;
      case "shady-2":
        this.setShadyMove(2);
        this.shadyMoves.frameTargets = this.shadyTarget;
        break;
      case "shady-3":
        this.setShadyMove(3);
        this.shadyMoves.trojanCube = this.shadyTarget[0];
        break;
      case "shady-4":
        this.setShadyMove(4);
        this.shadyMoves.propaganda = this.shadyTarget[0];
        break;
      default:
    }
  }

  setColor (color) {
    this.color = color;
  }

  setEvents (country,events) {
    if (country === this.country.object) {
      this.events = events;
      this.latestResults = this.country.object.latestResults;
    }
  }

  setCountry (country) {
    this.country = country;
    this.countryNo = this.country.object.name === "top-left" ?
      0 : (this.country.object.name === "bottom-left" ?
      1 : (this.country.object.name === "top-right" ?
      2: 3
    ));
    this.country.object.setPerk(this.perk);
  }

  decideGoal () {
    let randomMod = [
      'domestic-1',
      'domestic-2',
      'domestic-3',
      'domestic-4',
      'military-1',
      'military-2',
      'military-3',
      'military-4',
      'technology-1',
      'technology-2',
      'technology-3',
      'technology-4'
    ][Math.floor(Math.random() * 12)];
    this.modifier = randomMod;
  }

  allocateBeings () {
    this.country.options = {
      workerPercentage: 20,
      militaryPercentage: 20,
      educatorPercentage: 20
    };
    while ((this.country.options.militaryPercentage +
      this.country.options.workerPercentage +
      this.country.options.educatorPercentage) < 100) {
        this.country.options.militaryPercentage += Math.floor(Math.random()*2);
        this.country.options.educatorPercentage += Math.floor(Math.random()*2);
        this.country.options.workerPercentage += Math.floor(Math.random()*2);
    }
    while ((this.country.options.militaryPercentage +
      this.country.options.workerPercentage +
      this.country.options.educatorPercentage) > 100) {
        this.country.options.educatorPercentage -= 1;
    }

    this.country.object.allocateBeings(this.country.options);
  }

  decideTarget () {
    let target = [0,1,2,3][Math.floor(Math.random()*4)];
    this.country.view.game.attackCountry(this,target);
  }

  calculateTurn () {
    if (this.computer) {
      this.decideGoal();
      this.allocateBeings();
      this.decideTarget();
    }
  }
}

module.exports = Player;



/*****************
 ** WEBPACK FOOTER
 ** ./game/handlers/player.js
 ** module id = 15
 ** module chunks = 0
 **/